import { createBrowserHistory } from 'history';
import { LoginService } from '../services/login.service';
import { USER_ACTIONS } from './enums/user-store-actions.enum';
import userStore from '../store/userStore';
import { COGNITO_TOKEN_NAME, PERMISSIONS_TOKEN_NAME } from '../config';

function logout() {
    const history = createBrowserHistory();
    sessionStorage.clear();
    userStore.dispatch({
        type: USER_ACTIONS.LOGOUT,
        payload: undefined,
    });
    history.push('/login');
    location.reload();
}

/**
 * Start the session timeout counter thread
 */
const startSessionTimeout = () => {
    // set the expiration time
    setTimeout(() => {
        logout();
        // eslint-disable-next-line no-magic-numbers
    }, 60 * 60 * 1000);
};
/**
 * Start the token refresher interval counter thread
 */

const MILLISECONDS_IN_SECOND_REFRESH_TOKEN = 1000;
const SECONDS_IN_MINUTE_REFRESH_TOKEN = 60;
const REFRESH_INTERVAL_MINUTES_REFRESH_TOKEN = 2.5;

const refreshToken = (
    username: string,
    dispatch: Function,
    timer: NodeJS.Timeout | null,
    setTimer: (timer: NodeJS.Timeout | null) => void,
) => {
    if (timer) {
        clearInterval(timer);
    }
    const loginService = new LoginService();
    const newTimer = setInterval(() => {
        loginService
            .refreshToken(username)
            .then(({ data }: any) => {
                if (data.cognitoToken) {
                    sessionStorage.setItem(
                        COGNITO_TOKEN_NAME,
                        data.cognitoToken,
                    );
                    sessionStorage.setItem(
                        PERMISSIONS_TOKEN_NAME,
                        data.permissionsToken,
                    );
                    dispatch({
                        type: USER_ACTIONS.SET_TOKEN,
                        payload: {
                            cognitoToken: data.cognitoToken,
                            permissionsToken: data.permissionsToken,
                        },
                    });
                }
            })
            .catch(() => {
                logout();
            });
    }, REFRESH_INTERVAL_MINUTES_REFRESH_TOKEN * SECONDS_IN_MINUTE_REFRESH_TOKEN * MILLISECONDS_IN_SECOND_REFRESH_TOKEN);
    setTimer(newTimer);
};

/**
 * Timer for inactivity modal
 */
const MILLISECONDS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;
const INACTIVITY_TIMEOUT_MINUTES = 10;
const MINOR_INACTIVITY_TIMEOUT_MINUTES = 2;

export const INACTIVITY_TIMEOUT =
    INACTIVITY_TIMEOUT_MINUTES * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
export const MINOR_INACTIVITY_TIMEOUT =
    MINOR_INACTIVITY_TIMEOUT_MINUTES *
    SECONDS_IN_MINUTE *
    MILLISECONDS_IN_SECOND;

/**
 * Decode Token
 * */
const getPermissionInfo = async (token: any) => {
    const loginService = new LoginService();

    let userProfile;

    try {
        const request = await loginService.getDealerProfile(token);
        userProfile = request.data.userProfile;
    } catch (error) {
        userProfile = '';
        logout();
    }

    return userProfile;
};

export { startSessionTimeout, refreshToken, logout, getPermissionInfo };
